import React, { useEffect, useState, useContext } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CCard } from '@coreui/react'
import Loading from 'react-fullscreen-loading'
import useAxios from 'axios-hooks'
import { GlobalContext } from 'src/views/context/GlobalState'
import { AppContext } from 'src/views/context/app'
import { IPTV_CHANNEL_FILTER } from 'src/views/utils/urls'
import { isEmpty, capitalize } from 'lodash'
import PreviewDetails from '../../views/container/AssetManager/PreviewDetails'
import moment from 'moment'
import { getThumbnail } from 'src/views/utils/helper'
import CalendarTable from '../calendarTable/calendarTable'

const IPTVScheduleModal = () => {
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader, loader, iptvScheduleModalProps, setIptvScheduleModalProps } =
    useContext(AppContext)
  const { channelId } = iptvScheduleModalProps

  const [detailObj, setDetailObj] = useState({})
  const [previewContent, setPreviewContent] = useState({})
  const [basicInfo, setBasicInfo] = useState([])

  console.log('channelId', channelId)
  const [{ data: channelDetails, loading: channelDetailsLoading }, channelDetailsCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER,
      method: 'post',
    },
    {
      manual: true,
    },
  )

  useEffect(() => {
    channelDetailsCall({
      data: {
        filters: { channel_ids: [channelId] },
        page: '1',
      },
    })
  }, [channelId])

  useEffect(() => {
    setLoader(channelDetailsLoading)
  }, [channelDetailsLoading])

  useEffect(() => {
    if (channelDetails && channelDetails.success) {
      setDetailObj(channelDetails.data[0])
    }
  }, [channelDetails])

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Title',
        value: previewContent.title,
      },
      {
        property: 'Description',
        value: previewContent?.description,
      },
      {
        property: 'Content Type',
        value: previewContent?.video_type,
      },
      {
        property: 'File Type',
        value: previewContent?.asset_type,
      },

      {
        property: 'Category',
        value: !isEmpty(previewContent?.category)
          ? [...previewContent?.category].map((info) => info.name).toString()
          : '',
      },
      { property: 'Status', value: capitalize(String(previewContent?.publish_policy)) },
      {
        property: 'Monetization',
        value:
          previewContent?.active_subscription?.length > 0 ||
          previewContent?.active_ppv_subscription?.length > 0
            ? 'Paid'
            : 'Free',
      },
      {
        property: 'Publish Time',
        value: moment(previewContent?.publish_time).format('DD MMM YYYY'),
      },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [previewContent])

  return (
    <CModal scrollable size="xl" visible={true} alignment="center" className="iptv-schedule-modal">
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />

      <CModalBody className=" position-relative">
        <div className="d-flex items-center position-absolute z-20 mt-[12px] 2xl:mt-0">
          <img
            src={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              detailObj?.thumbnail?.website?.s3_key,
            )}
            alt="channelimg"
            className="rounded-md"
            style={{ width: '6.1vw', height: '3.4vw' }}
          />
          <p style={{ fontSize: '1.5625vw', fontWeight: '550' }} className="mb-0 ml-3">
            {`Schedule your Content on '${detailObj?.name}' Channel`}
          </p>
        </div>
        <CCard className="mt-3 border-0">
          {!isEmpty(previewContent) && (
            <PreviewDetails
              onClose={() => setPreviewContent({})}
              cardImage={getThumbnail(
                userSessionObj.session_data.cf_domain_name,
                previewContent?.thumbnail?.website?.s3_key,
              )}
              headline="Content Preview"
              subHeadline="Detailed information about the selected Content"
              basicInfo={basicInfo}
              resolutions={previewContent?.source_asset?.progress}
              playIconForVideo={true}
            />
          )}
          <CalendarTable
            channelId={channelId}
            setPreviewDetails={setPreviewContent}
            addNewDisabled={true}
          />
        </CCard>
      </CModalBody>
      <CModalFooter className="mx-4">
        <CButton
          style={{ fontSize: '1.1rem' }}
          className=" bg-black rounded-1 btn-focus-none"
          onClick={() => setIptvScheduleModalProps({})}
        >
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default IPTVScheduleModal
